import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { ComponentUtilsService } from './component-utils.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  public static readonly ENDPOINT_REVOKE = 'revoke';
  public static readonly ENDPOINT_USERNAME = 'username';
  public static readonly ENDPOINT_TOKEN = 'token';

  constructor(
    protected httpClient: HttpClient,
    protected componentUtilsService: ComponentUtilsService,
  ) {}

  revoke(account, provider = 'google') {
    const serverUrl =
      provider === 'google'
        ? environment.GOOGLE_SERVICE_URL
        : environment.DATA_SERVICE_URL;
    const request = new HttpRequest(
      'GET',
      serverUrl + GoogleService.ENDPOINT_REVOKE,
      {
        withCredentials: true,
        responseType: 'json',
        params: new HttpParams({
          fromObject: {
            account: account,
            provider: provider,
          },
        }),
      },
    );

    return this.httpClient
      .request(request)
      .toPromise()
      .then((response: any) => {
        if (response && response.body && response.body.revoked) {
          return response.body.revoked;
        } else {
          throw new Error('Failed to revoke account');
        }
      })
      .catch((err) => {
        console.error('Failed to revoke access for user.', err);

        throw err;
      });
  }

  getUsername(account) {
    const body = { account };
    const request = new HttpRequest(
      'POST',
      environment.GOOGLE_SERVICE_URL + GoogleService.ENDPOINT_USERNAME,
      body,
      this.componentUtilsService.getRequestOptions(),
    );

    return this.httpClient
      .request(request)
      .toPromise()
      .then((response: any) => {
        if (response.body) {
          return { username: response.body.username };
        } else {
          throw new Error('Failed to get username');
        }
      })
      .catch((err) => {
        console.error('Failed to get username.', err);
        throw err;
      });
  }

  getToken(account, provider, signature) {
    const body = {
      account,
      provider,
      signature,
    };

    const request = new HttpRequest(
      'POST',
      environment.DATA_SERVICE_URL + GoogleService.ENDPOINT_TOKEN,
      body,
      { responseType: 'json' },
    );

    return this.httpClient
      .request(request)
      .toPromise()
      .then((response: any) => {
        if (response && response.body && response.body.access_token) {
          return response.body.access_token;
        } else {
          throw new Error('Invalid token');
        }
      })
      .catch((err) => {
        console.error('Failed to get token.', err);

        throw err;
      });
  }
}
